module.exports = __webpack_public_path__ + "static/img/link_img.da92d01a.svg";